<template>
  <div style='box-shadow: -12px 13px 10px #1e3456;height:800px'>
    <div class="totalPie">
      <div class="tit">
        <p>本月巡查记录</p>
      </div>
      <div class="neirongs">
        <ul class="contents">
          <li v-for="(item,i) in xcData" :key="i">
            <div class="leftContent">
              <p>{{i+1}}</p>
              <p>{{item.ydbXjrq}}</p>
              <p></p>
              <p>巡查异常：{{item.ydbYczk}}</p>
            </div>
            <div class="rightContent">
              <p :title="item.ydbBaZhi">{{item.ydbBaZhi}}</p>
              <p @click="jlClick(item)">详细记录</p>
              <p @click="zjClick(item)">足迹回放</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Dialog v-if="DialogVisible==true" @cancel="Cancel" :DialogData="DialogData"></Dialog>
  </div>
</template>

<script>
  import {
    xqXunJianRecord
  } from "@/api/api";
  import Dialog from "./xxjlDialog.vue";
  export default {
    data() {
      return {
        xcData: [],
        DialogData: [],
        DialogVisible: false,
      };
    },
    components: {
      Dialog,
    },
    mounted() {},
    computed: {
      nowxingzhengCodes() {
        return this.$store.state.nowxingzhengCode; //需要监听的数据
      },
    },
    watch: {
      nowxingzhengCodes(newVal, oldVal) {
        // console.log(newVal)
        let params = {
          ydbCode: newVal,
          identity: 1
        };
        this.xqXunJianRecordFun(params);
      },
    },
    methods: {
      xqXunJianRecordFun(params) {
        this.xcData = [];
        xqXunJianRecord(params).then((res) => {
          // console.log(res)
          for (let i=0; i<res.data.length; i++) {
            this.xcData = res.data;
          }
        });
      },
      jlClick(item) {
        // console.log(item)
        this.DialogData = item;
        this.DialogVisible = true;
      },
      zjClick(item) {
        this.$store.state.motionData = item;
      },
      Cancel() {
        this.DialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  .totalPie {
    width: 100%;
    height: 800px;
    background: url(../../common/images/dbg.png) no-repeat center;
    background-size: 102% 101%;
    overflow: hidden;
  }

  .neirongs {
    width: 96%;
    margin-left: 2%;
    height: 740px;
    overflow: auto;
  }

  .contents {
    width: 96%;
    margin-left: 2%;
    height: 720px;
  }

  .contents li {
    width: 100%;
    height: 80px;
    margin-top: 20px;
    border: 1px solid #00B3FE;
    font-size: 14px;
    color: #fff;
    transition: all 0.2s;
    -webkit-transition: all 0.2s;
  }

  .contents li:hover {
    transform: scale(1.01);
    -ms-transform: scale(1.01);
    -moz-transform: scale(1.01);
    -webkit-transform: scale(1.01);
    -o-transform: scale(1.01);
  }

  .leftContent {
    float: left;
    width: 40%;
    height: 100%;
    margin-left: 5%;
  }

  .leftContent p:nth-child(1) {
    float: left;
    font-size: 12px;
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    margin-top: 12px;
    margin-right: 10px;
    border: 1px solid #00B3FE;
  }

  .leftContent p:nth-child(2) {
    float: left;
    width: 80%;
    height: 40px;
    line-height: 40px;
    text-align: left;
  }

  .leftContent p:nth-child(3) {
    float: left;
    width: 8px;
    height: 8px;
    line-height: 14px;
    margin-top: 15px;
    margin-right: 10px;
    background-color: #00B3FE;
  }

  .leftContent p:nth-child(4) {
    float: left;
    width: 80%;
    height: 40px;
    line-height: 40px;
    text-align: left;
  }

  .rightContent {
    float: left;
    width: 55%;
    height: 100%;
  }

  .rightContent p:nth-child(1) {
    float: left;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .rightContent p:nth-child(2) {
    float: left;
    width: 34%;
    height: 24px;
    line-height: 24px;
    margin-left: 8%;
    margin-right: 8%;
    margin-top: 8px;
    font-size: 12px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    border-radius: 10%;
    cursor: pointer;
    background-color: #1CEA58;
  }

  .rightContent p:nth-child(2):hover {
    color: blue;
  }

  .rightContent p:nth-child(3) {
    float: left;
    width: 34%;
    height: 24px;
    line-height: 24px;
    margin-left: 8%;
    margin-right: 8%;
    margin-top: 8px;
    font-size: 12px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    border-radius: 10%;
    cursor: pointer;
    background-color: #FFE557;
  }

  .rightContent p:nth-child(3):hover {
    color: blue;
  }
</style>
